import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Loading from '../pages/LoadingPage';
import { useUser } from './UserContext';
import { sessionCheck } from '../Users';

export const ProtectedRoute = ({ element }) => {
  const [isAuth, setIsAuth] = useState(3);
  const { setUser } = useUser();

  useEffect(() => {
    const checkAuth = async () => {
      const authResult = await isAuthenticated();

      if (authResult[0] === 2) {
        setIsAuth(2);
        setUser({
          id: Number(authResult[1]),
          status: Number(authResult[2]),
          blockCount: Number(authResult[3])
        });
      } else {
        setIsAuth(1);
      }
    };

    checkAuth();
  }, [setUser]);

  const isAuthenticated = async () => {
    try {
      const res = await sessionCheck();
      if (res.valid === true) {
        return [2, res.id, res.status, res.blockCount];
      }
      return [1];
    } catch (err) {
      console.log(err);
      return [1];
    }
  };

  if (isAuth === 3) {
    return <Loading />;
  }

  return isAuth === 2 ? element : <Navigate to="/login" replace />;
};